import { apiUrl, apiUrl2 } from '../../../settings'

export const getPerformanceReportUrl = () => {
  return apiUrl2 + '/agent/performance-report'
}

export const getAllNewScheduleMeetingsUrl = () => {
  return apiUrl2 + '/agent/meeting-record'
}

export const getAgentSignedContractListUrl = () => {
  return apiUrl2 + '/agent/signed-contract-list'
}
export const getAgentFanTourListUrl = () => {
  return apiUrl2 + '/agent/cyprus-famTourList'
}

export const updateMarketingUserInAllAgentUrl = () => {
  return apiUrl + '/updateMarketingUserInMultipleAgentFxn'
}